module.exports = __webpack_public_path__ + "img/background.a0867e47.jpg";